// @flow strict

import * as React from 'react'
import {
  type PropsWithChildren,
  BlogCard,
  Button,
  slugifyString,
} from '@mondough/public-web-components'
import cx from 'classnames'
import { SectionWrapper, SectionThemes } from './SectionWrapper'
import styles from './BlogRollSection.module.scss'
import { useGetBlogRoll } from '../utils/contentfulUtils'

type BlogRollProps = {|
  categoryName: string,
  numRows: number,
  reverse: boolean,
  cta?: {|
    text: string,
    href: string,
  |},
|}

const formatPosts = posts =>
  posts &&
  posts.map(post => ({
    ...post,
    title: post.blogTitle,
    webSlug: '/blog' + (post.webSlug || ''),
    description: { text: post.description },
    ogImage: post.ogImage && post.ogImage.fields,
  }))

const BlogRollSection = ({
  categoryName,
  numRows,
  reverse,
  cta,
  children,
}: PropsWithChildren<BlogRollProps>) => {
  const [posts, error, isLoading] = useGetBlogRoll(categoryName, 3 * numRows)
  if (error != null || posts == null) {
    return null
  }

  const blogRoll = posts.map(p => p.fields)

  return (
    !isLoading && (
      <SectionWrapper
        theme={SectionThemes.LIGHT}
        className={reverse ? styles.reverseSection : styles.sectionStyle}
        contentClassName={cx(styles.baseContent, {
          [styles.withSubtitle]: !!children,
        })}
      >
        {children}
        <div>
          <ul className={styles.list}>
            {formatPosts(blogRoll).map(post => (
              <li key={post.title} className={styles.column}>
                <BlogCard slugPrefixForATag={'https://monzo.com'} post={post} />
              </li>
            ))}
          </ul>
        </div>
        {
          <div className={styles.ctaContainer}>
            <Button
              href={`https://monzo.com/blog/${slugifyString(categoryName)}`}
            >
              Read more...
            </Button>
          </div>
        }
      </SectionWrapper>
    )
  )
}

export default BlogRollSection
